export class GeneralRoutes {
	home() {
		return '/';
	}
}
